import { TipoFiltroDataRelatorioPrestacaoContas } from "../typings";
import moment from "moment";
import { showError } from "../../../../../infra/helpers/alerta";

export function getDateFromTipoFiltroData(
  tipoFiltroData?: TipoFiltroDataRelatorioPrestacaoContas,
  filtrosAdicionais?: { mesEspecifico?: string },
  mes?: string
) {
  const _mes = mes ? moment(mes, "YYYY-MM") : moment();

  if (!tipoFiltroData) {
    return {
      dataInicio: null,
      dataFim: _mes.endOf("day").format("YYYY-MM-DD"),
    };
  }

  switch (tipoFiltroData) {
    case TipoFiltroDataRelatorioPrestacaoContas.TodosOsMeses:
      return {
        dataInicio: null,
        dataFim: moment().endOf("day").format("YYYY-MM-DD"),
      };
    case TipoFiltroDataRelatorioPrestacaoContas.MesAtual:
      return {
        dataInicio: _mes.startOf("month").format("YYYY-MM-DD"),
        dataFim: _mes.endOf("month").format("YYYY-MM-DD"),
      };
    case TipoFiltroDataRelatorioPrestacaoContas.MesAnterior:
      return {
        dataInicio: _mes
          .subtract(1, "month")
          .startOf("month")
          .format("YYYY-MM-DD"),
        dataFim: _mes.subtract(1, "month").endOf("month").format("YYYY-MM-DD"),
      };
    case TipoFiltroDataRelatorioPrestacaoContas.DoisMesesAtras:
      return {
        dataInicio: _mes
          .subtract(2, "month")
          .startOf("month")
          .format("YYYY-MM-DD"),
        dataFim: _mes.subtract(2, "month").endOf("month").format("YYYY-MM-DD"),
      };
    case TipoFiltroDataRelatorioPrestacaoContas.ProximoMes:
      return {
        dataInicio: _mes.add(1, "month").startOf("month").format("YYYY-MM-DD"),
        dataFim: _mes.add(1, "month").endOf("month").format("YYYY-MM-DD"),
      };
    case TipoFiltroDataRelatorioPrestacaoContas.AnoAnterior:
      return {
        dataInicio: _mes
          .subtract(1, "year")
          .startOf("year")
          .format("YYYY-MM-DD"),
        dataFim: _mes.subtract(1, "year").endOf("year").format("YYYY-MM-DD"),
      };
    case TipoFiltroDataRelatorioPrestacaoContas.AnoAtual:
      return {
        dataInicio: _mes.startOf("year").format("YYYY-MM-DD"),
        dataFim: _mes.endOf("year").format("YYYY-MM-DD"),
      };
    case TipoFiltroDataRelatorioPrestacaoContas.ProximoAno:
      return {
        dataInicio: _mes.add(1, "year").startOf("year").format("YYYY-MM-DD"),
        dataFim: _mes.add(1, "year").endOf("year").format("YYYY-MM-DD"),
      };
    case TipoFiltroDataRelatorioPrestacaoContas.MesEspecifico:
      if (!filtrosAdicionais?.mesEspecifico) {
        showError(
          "Erro na configuração do relatório com filtro de mês específico. Tente modificar o mesmo."
        );

        return {
          dataInicio: null,
          dataFim: _mes.endOf("day").format("YYYY-MM-DD"),
        };
      }

      return {
        dataInicio: moment(filtrosAdicionais?.mesEspecifico, "YYYY-MM")
          .startOf("month")
          .format("YYYY-MM-DD"),
        dataFim: moment(filtrosAdicionais?.mesEspecifico, "YYYY-MM")
          .endOf("month")
          .format("YYYY-MM-DD"),
      };
  }
}
